import { createRouter, createWebHashHistory } from 'vue-router'
import tool from '@/common/tool'
// import share from '@/common/share'
import axios from '@/common/axios'
import urls from '@/common/urls'
import store from '@/store'
import config from '../common/config'
import { routerBefore } from './routerBefore'
const commonRoutes = [
  {
    path: '/:pathMatch(.*)*',
    name: 'page404',
    component: () => import(/* webpackChunkName "page404" */ '@/components/help/page404.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName "login" */ '@/components/login.vue')
  },
  {
    path: '/',
    name: '/',
    component: () => import(/* webpackChunkName "/" */ '@/components/index.vue')
  },
  {
    path: '/index',
    name: 'index',
    component: () => import(/* webpackChunkName "index" */ '@/components/index.vue')
  },
];
const ignoreRoutes = [
];
const routes = [].concat(commonRoutes, ignoreRoutes);
const router = createRouter({
  history: createWebHashHistory(),
  routes
});
const ignorePages = ignoreRoutes.map(item => item.name) // 不需要验证的页面
const jumpPath = ["page404", "login"]
router.beforeEach((to, from, next) => {
  if (ignorePages.includes(to.name) || jumpPath.includes(to.name) || !config.authentication) {
    next();
    return;
  }
  const data = tool.getStorage('userInfo') || {}
  if (store.state.common.userInfo.id) {
    next()
    return;
  }
  if (data.email) {
    login(to, from, next)
    return;
  }
  // next()
  next('/login');
})

//进行登录操作
const login = (to, from, next) => {
  let data = tool.getStorage("userInfo")
  axios.post(urls.user.login, data).then((res) => {
    tool.setStorage("userInfo", data)
    store.dispatch("setItem", { userInfo: res.data })
    next()
  }).catch((err) => {
    console.log("err======",err)
    // next()
    next('/login')
  })
}
export default router;